class ConvertString {

    addData = (param) => {
        let Items = []

        param.forEach((v) => {

            const Item = this.__getItem(v);
            Items.push(Item)
        })

        return Items
    }

    __getItem = (v) => {

        let Item = v.content

        if (v.riferimentiHtml) {
            let riferimenti = v.riferimentiHtml
            riferimenti.forEach((value) => {
                const render = this.__getRiferimenti(Item, value)
                Item = render
            })
        }
        return Item;
    }

    __getRiferimenti = (Item, value) => {
        if (value.validity === null && typeof value.ext_source !== 'undefined') {
            let a = Item
            let b = `<a href="${value.ext_source}" target="_blank">`
            let c = a.slice(value.startPosition, value.endPosition)
            let d = "</a>"
            let closure = value.endPosition
            let position = value.startPosition;
            let render = [
                a.slice(0, position),
                b,
                c,
                d,
                a.slice(closure)
            ].join('');

            Item = render
        } else if (value.validity === 0) {
            let a = Item
            let b = `<u><strong>`
            let c = a.slice(value.startPosition, value.endPosition)
            let d = "</strong></u>"
            let closure = value.endPosition
            let position = value.startPosition;
            let render = [
                a.slice(0, position),
                b,
                c,
                d,
                a.slice(closure)
            ].join('');

            Item = render
        } else {

            let a = Item
            let b = `<a href=${value.reference} data-start=${value.startPosition} data-end=${value.endPosition} id="foo">`
            let c = a.slice(value.startPosition, value.endPosition)
            let d = "</a>"
            let closure = value.endPosition
            let position = value.startPosition;
            let render = [
                a.slice(0, position),
                b,
                c,
                d,
                a.slice(closure)
            ].join('');

            Item = render
        }

        return Item;
    }
}

export default new ConvertString()